(() => {
/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 *
 * Based on the below, with some changes for the datatracker:
 * https://github.com/twbs/bootstrap/blob/main/site/static/docs/5.3/assets/js/color-modes.js
 */ (()=>{
    'use strict';
    const getStoredTheme = ()=>localStorage.getItem('theme') || 'auto';
    const setStoredTheme = (theme)=>localStorage.setItem('theme', theme);
    const getPreferredTheme = ()=>{
        const storedTheme = getStoredTheme();
        if (storedTheme) return storedTheme;
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    };
    const setTheme = (theme)=>{
        if (theme === 'auto') {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) document.documentElement.setAttribute('data-bs-theme', 'dark');
            else if (window.matchMedia('(prefers-color-scheme: light)').matches) document.documentElement.setAttribute('data-bs-theme', 'light');
        } else document.documentElement.setAttribute('data-bs-theme', theme);
    };
    setTheme(getPreferredTheme());
    const showActiveTheme = (theme, focus = false)=>{
        const themeSwitcher = document.querySelector('#bd-theme');
        if (!themeSwitcher) return;
        // Commented-out lines are from the original bs5 js, which uses a more complicated pref dropdown.
        // Kept them here for easier future diffing.
        const themeSwitcherText = document.querySelector('#bd-theme-text');
        const activeThemeIcon = document.querySelector('.theme-icon-active');
        const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`);
        const iconPattern = new RegExp(/\bbi-[\w-]+\b/);
        const iconOfActiveBtn = btnToActive.querySelector('i').className.match(iconPattern)[0];
        document.querySelectorAll('[data-bs-theme-value]').forEach((element)=>{
            element.classList.remove('active');
            element.setAttribute('aria-pressed', 'false');
        });
        btnToActive.classList.add('active');
        btnToActive.setAttribute('aria-pressed', 'true');
        if (activeThemeIcon) activeThemeIcon.className = activeThemeIcon.className.replace(iconPattern, iconOfActiveBtn);
        if (themeSwitcherText) {
            const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`;
            themeSwitcher.setAttribute('aria-label', themeSwitcherLabel);
        }
        if (focus) themeSwitcher.focus();
    };
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', ()=>{
        const storedTheme = getStoredTheme();
        if (storedTheme !== 'light' && storedTheme !== 'dark') setTheme(getPreferredTheme());
    });
    window.addEventListener('DOMContentLoaded', ()=>{
        showActiveTheme(getPreferredTheme());
        document.querySelectorAll('[data-bs-theme-value]').forEach((toggle)=>{
            toggle.addEventListener('click', ()=>{
                const theme = toggle.getAttribute('data-bs-theme-value');
                setStoredTheme(theme);
                setTheme(theme);
                showActiveTheme(theme, true);
            });
        });
    });
})();

})();
//# sourceMappingURL=theme.js.map
